import { Box, IconButton, Typography } from "@mui/material"
import { Edit, Info } from "@mui/icons-material"
import { useTranslation } from "react-i18next"
import useUserCanWriteAndDelete from "../hooks/permissions"
import { useIsMobile } from "../hooks/mobile"

type SectionTitleProps = {
  title?: string
  onEdit?: () => void
  bgcolor?: string
  containerBgColor?: string
  info?: boolean
  first?: boolean
}

export function SectionTitle({
  title,
  onEdit,
  bgcolor = "primary.main",
  containerBgColor = "grey.100",
  info = false,
  first = false,
}: SectionTitleProps) {
  
  const { t } = useTranslation()

  const userCanWriteAndDelete = useUserCanWriteAndDelete()
  const isMobile = useIsMobile()

  return (
    <Box
      sx={{
        backgroundColor: containerBgColor,
        overflow: "hidden",
        borderRadius: first ? 1 : 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
      }}
    >
      <Box
        bgcolor={bgcolor}
        color={"primary.contrastText"}
        sx={{
          p: 1,
          px: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: 56,
        }}
      >
        {info ? (
          <Typography variant="h6" component="h2">{t("sections.info")}</Typography>
        ) : (
          <Typography variant={
            isMobile ? "subtitle2" : "h6"
          } component="h2">{title}</Typography>
        )}
        {!!onEdit && userCanWriteAndDelete && !isMobile && (
          <IconButton sx={{ bgcolor, color: "primary.contrastText" }} onClick={onEdit} aria-label="edit">
            <Edit />
          </IconButton>
        )}
        {info && (
          <Box sx={{ bgcolor, color: "primary.contrastText", display: "flex", alignItems: "center" }}>
            <Info />
          </Box>
        )}
      </Box>
    </Box>
  )
}
